import * as Yup from 'yup';

export const ClientPromoEditValidationSchema = Yup.object().shape({
  promoId: Yup.string()
    .required('Укажите промоакцию')
    .nullable(),
  sourceProjectId: Yup.string()
    .required('Укажите проект')
    .nullable(),

});
